export default {
  props: {
    src: String
  },
  methods: {
    handleLoad: function handleLoad() {
      this.$emit('load');
    }
  }
};